module.exports = __webpack_public_path__ + "static/maruya-cassava-0cd2f577dfb10005b1049e75f04f9e2d.jpg";